// @flow
import type { TRound } from "../../../modules/types";
import type { TPLeague } from '../../../modules/types/league';

export const isDraftLeagueByeRound = (league: TPLeague, round: TRound) => {
	if (league && round) {
		return Boolean(league.bye_rounds) ? false : round.is_bye;
	}

	return false;
};


// WEBPACK FOOTER //
// ./src/helpers/complex/leagues/index.js